/**
 * Où arrive chacun après la connexion : là où il travaille, pas sur « Mon
 * compte ». Mesuré en recette : tous les rôles atterrissaient sur leur fiche
 * de compte, et chaque journée commençait par un clic de trop.
 *
 * L'ordre compte : un praticien lit aussi les fiches patient, mais sa
 * journée est sa file ; un agent d'accueil note les entrées ; la chargée de
 * clientèle traite les DNS. La Direction arrive sur son tableau de bord
 * quand il est allumé (décisions 214 et 220), sur Affluences sinon. Le Super
 * administrateur, qui détient tout (décision 418), arrive sur les comptes :
 * sans cette ligne, `dossier_medical:write` l'enverrait sur « Ma file », qui
 * n'est qu'aux praticiens. Le chef de centre non médecin arrive sur les
 * comptes de son centre ; « Médecin + chef de centre », de base MEDECIN,
 * garde Ma file.
 */
import { CODE_CHEF_CENTRE, type Fonctions, type Permission, type Role } from '@afs/shared'

/** Décision 449 — la page du chef de centre, « Comptes de mon centre ». */
export const PAGE_COMPTES_DU_CENTRE = '/centre/comptes'

const DESTINATIONS: readonly {
  readonly permissions: readonly Permission[]
  readonly page: string
  readonly role?: Role
  readonly fonction?: keyof Fonctions
}[] = [
  { permissions: ['utilisateur:read'], role: 'SUPER_ADMIN', page: '/administration/utilisateurs' },
  {
    permissions: ['utilisateur:write_centre'],
    role: CODE_CHEF_CENTRE,
    page: PAGE_COMPTES_DU_CENTRE,
  },
  { permissions: ['dossier_medical:write'], page: '/parcours/ma-file' },
  { permissions: ['file_attente:write', 'patient:read'], page: '/accueil' },
  { permissions: ['dns:import'], page: '/dns' },
  {
    permissions: ['dashboard:read'],
    role: 'DIRECTION',
    fonction: 'tableauDeBord',
    page: '/pilotage/tableau-de-bord',
  },
  { permissions: ['dashboard:read'], page: '/pilotage/affluences' },
  { permissions: ['utilisateur:read'], page: '/administration/utilisateurs' },
  { permissions: ['patient:read'], page: '/accueil' },
]

export const PAGE_MON_COMPTE = '/mon-compte'

export function pageDAccueil(
  permissions: readonly Permission[],
  contexte: { readonly role?: Role | undefined; readonly fonctions?: Partial<Fonctions> } = {},
): string {
  return (
    DESTINATIONS.find(
      (d) =>
        d.permissions.every((p) => permissions.includes(p)) &&
        (d.role === undefined || d.role === contexte.role) &&
        (d.fonction === undefined || contexte.fonctions?.[d.fonction] === true),
    )?.page ?? PAGE_MON_COMPTE
  )
}
